// extracted by mini-css-extract-plugin
module.exports = {"currency_cell":"_currency-cell_currency_cell__q/OVK"};